import StatusDetail from "@/domain/entities/user/StatusDetail";
import UserStatus from "@/domain/enums/UserStatus";
import { StatusDetail as StatusDetailMailvista } from "@cs_teamwaydev/mailvista-sdk_react";

const statusDetailToDomainMapper = (
    statusDetail: StatusDetailMailvista,
): StatusDetail =>
    new StatusDetail({
        status: statusDetail.status as UserStatus,
        holdDate: statusDetail.holdDate,
        deactivatedDate: statusDetail.deactivatedDate,
        archivedDate: statusDetail.archivedDate,
    });

const statusDetailToSDKMapper = (
    statusDetail: StatusDetail,
): StatusDetailMailvista => ({
    status: statusDetail.status as UserStatus,
    holdDate: statusDetail.holdDate,
    deactivatedDate: statusDetail.deactivatedDate,
    archivedDate: statusDetail.archivedDate,
});

export { statusDetailToDomainMapper, statusDetailToSDKMapper };
